<table>
  <colgroup>
    <col style="width: 96px" />
    <col style="width: 210px" />
    <col style="width: 135px" />
    <col style="width: 557px" />
  </colgroup>
  <tbody>
    <tr>
      <th rowspan="1" colspan="1" colorname="" data-colwidth="97">
        <div class="ak-renderer-tableHeader-sortable-column">
          <p data-renderer-start-pos="2363"><span class="title">ICF-Score</span></p>
          <figure class="ak-renderer-tableHeader-sorting-icon__wrapper ak-renderer-tableHeader-sorting-icon__no-order">
            <div role="presentation">
              <div
                class="ak-renderer-tableHeader-sorting-icon cc-nnufw"
                role="button"
                tabindex="0"
                aria-label="Keine Sortierung auf die Spalte angewendet"
                aria-disabled="false">
                <div class="sorting-icon-svg__no_order ak-renderer-tableHeader-sorting-icon-inactive cc-37vp66">
                  <div class="cc-5gbtdb"></div>
                </div>
              </div>
            </div>
          </figure>
        </div>
      </th>
      <th rowspan="1" colspan="1" colorname="" data-colwidth="211">
        <div class="ak-renderer-tableHeader-sortable-column">
          <p data-renderer-start-pos="2376"><span class="title">Kurzbeschreibung</span></p>
          <figure class="ak-renderer-tableHeader-sorting-icon__wrapper ak-renderer-tableHeader-sorting-icon__no-order">
            <div role="presentation">
              <div
                class="ak-renderer-tableHeader-sorting-icon cc-nnufw"
                role="button"
                tabindex="0"
                aria-label="Keine Sortierung auf die Spalte angewendet"
                aria-disabled="false">
                <div class="sorting-icon-svg__no_order ak-renderer-tableHeader-sorting-icon-inactive cc-37vp66">
                  <div class="cc-5gbtdb"></div>
                </div>
              </div>
            </div>
          </figure>
        </div>
      </th>
      <th rowspan="1" colspan="1" colorname="" data-colwidth="136">
        <div class="ak-renderer-tableHeader-sortable-column">
          <p data-renderer-start-pos="2396"><span class="title">Quantifizierung</span></p>
          <figure class="ak-renderer-tableHeader-sorting-icon__wrapper ak-renderer-tableHeader-sorting-icon__no-order">
            <div role="presentation">
              <div
                class="ak-renderer-tableHeader-sorting-icon cc-nnufw"
                role="button"
                tabindex="0"
                aria-label="Keine Sortierung auf die Spalte angewendet"
                aria-disabled="false">
                <div class="sorting-icon-svg__no_order ak-renderer-tableHeader-sorting-icon-inactive cc-37vp66">
                  <div class="cc-5gbtdb"></div>
                </div>
              </div>
            </div>
          </figure>
        </div>
      </th>
      <th rowspan="1" colspan="1" colorname="" data-colwidth="558">
        <div class="ak-renderer-tableHeader-sortable-column">
          <p data-renderer-start-pos="2415"><span class="title">Erläuterung</span></p>
          <figure class="ak-renderer-tableHeader-sorting-icon__wrapper ak-renderer-tableHeader-sorting-icon__no-order">
            <div role="presentation">
              <div
                class="ak-renderer-tableHeader-sorting-icon cc-nnufw"
                role="button"
                tabindex="0"
                aria-label="Keine Sortierung auf die Spalte angewendet"
                aria-disabled="false">
                <div class="sorting-icon-svg__no_order ak-renderer-tableHeader-sorting-icon-inactive cc-37vp66">
                  <div class="cc-5gbtdb"></div>
                </div>
              </div>
            </div>
          </figure>
        </div>
      </th>
    </tr>
    <tr>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="97"><p data-renderer-start-pos="2432">0</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="211">
        <p data-renderer-start-pos="2437">Keine Schädigung</p>
      </td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="136"><p data-renderer-start-pos="2457">0–4 %</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="558">
        <p data-renderer-start-pos="2466">
          Die Person hat keine oder kaum spürbare Einschränkungen. Sie kann die jeweilige Funktion vollständig und ohne
          Schwierigkeiten ausführen.
        </p>
      </td>
    </tr>
    <tr>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="97"><p data-renderer-start-pos="2608">1</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="211">
        <p data-renderer-start-pos="2613">Leichte Schädigung</p>
      </td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="136"><p data-renderer-start-pos="2635">5–24 %</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="558">
        <p data-renderer-start-pos="2645">
          Es gibt leichte Einschränkungen, die Aktivitäten oder Teilhabe nur minimal beeinträchtigen. Die Funktion ist
          mit geringen Schwierigkeiten durchführbar.
        </p>
      </td>
    </tr>
    <tr>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="97"><p data-renderer-start-pos="2802">2</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="211">
        <p data-renderer-start-pos="2807">Mäßige Schädigung</p>
      </td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="136"><p data-renderer-start-pos="2828">25–49 %</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="558">
        <p data-renderer-start-pos="2839">
          Es bestehen spürbare Einschränkungen, die die Funktion oder Aktivität merklich erschweren. Die Person benötigt
          teilweise Unterstützung oder Hilfsmittel.
        </p>
      </td>
    </tr>
    <tr>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="97"><p data-renderer-start-pos="2997">3</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="211">
        <p data-renderer-start-pos="3002">Schwere Schädigung</p>
      </td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="136"><p data-renderer-start-pos="3024">50–95 %</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="558">
        <p data-renderer-start-pos="3035">
          Die Einschränkungen sind erheblich und erschweren die Funktion stark. Die Person kann die Aktivität nur
          eingeschränkt und mit intensiver Unterstützung durchführen.
        </p>
      </td>
    </tr>
    <tr>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="97"><p data-renderer-start-pos="3204">4</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="211">
        <p data-renderer-start-pos="3209">Volle Schädigung</p>
      </td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="136"><p data-renderer-start-pos="3229">96–100 %</p></td>
      <td rowspan="1" colspan="1" colorname="" data-colwidth="558">
        <p data-renderer-start-pos="3241">
          Die Funktion ist vollständig beeinträchtigt oder gar nicht mehr vorhanden. Die Person ist in diesem Bereich
          vollständig abhängig von Hilfe und kann die Aktivität nicht eigenständig durchführen.
        </p>
      </td>
    </tr>
  </tbody>
</table>
